import { fromEvent, merge } from 'rxjs';
import { distinctUntilKeyChanged, filter, map, withLatestFrom } from 'rxjs/operators';
import { FTV_OUTLINE } from '../../ui/theme/constants';
import { FOCUS_NEXT_ELEMENT, FOCUS_PREVIOUS_ELEMENT } from '../shortcut/types';

export default class AccessibilityController {
  constructor(player) {
    this.player = player;

    this.navigation$ = AccessibilityController.setupNavigationStream(
      player.shortcutController.shortcuts$,
      player.focused$
    );

    AccessibilityController
      .outline(player.shortcutController.shortcuts$)
      .subscribe(({ event, outline }) => {
        // eslint-disable-next-line no-param-reassign
        event.target.style.boxShadow = outline ? FTV_OUTLINE : 'unset';
        // eslint-disable-next-line no-param-reassign
        event.target.style.borderRadius = outline ? '2px' : '0px';
      });
  }

  static isTabKey(keyCode) {
    return (keyCode === FOCUS_NEXT_ELEMENT || keyCode === FOCUS_PREVIOUS_ELEMENT);
  }

  static setupNavigationStream(keyDown$, focused$) {
    return merge(
      keyDown$.pipe(filter((keyCode) => AccessibilityController.isTabKey(keyCode))),
      focused$.pipe(filter(Boolean))
    );
  }

  static outline(shortcuts$) {
    return merge(
      AccessibilityController.createMagnetoBlurStream(),
      AccessibilityController.createMagnetoFocusStream(shortcuts$)
    ).pipe(distinctUntilKeyChanged('outline'));
  }

  static createMagnetoBlurStream() {
    const magnetoWrapper = document.getElementsByClassName('magneto-wrapper');
    return fromEvent(magnetoWrapper, 'blur').pipe(map((event) => ({ event, outline: false })));
  }

  static createMagnetoFocusStream(shortcuts$) {
    const magnetoWrapper = document.getElementsByClassName('magneto-wrapper');
    return fromEvent(magnetoWrapper, 'focus')
      .pipe(
        withLatestFrom(shortcuts$),
        filter(([, keyCode]) => AccessibilityController.isTabKey(keyCode)),
        map(([event]) => ({ event, outline: true }))
      );
  }
}
